<script setup lang="ts">
import RoleCards from '@/views/apps/roles/RoleCards.vue'
import UserList from '@/views/apps/roles/UserList.vue'

// Define page meta for CASL permissions
definePage({
  meta: {
    action: 'manage',
    subject: 'Role',
  },
})

const { t } = useI18n()

// Ref for UserList component
const userListRef = ref()

// Handle refresh event from RoleCards
const handleRefreshUserList = () => {
  if (userListRef.value)
    userListRef.value.loadUsers()
}
</script>

<template>
  <section>
    <!-- 👉 Page Header -->
    <div class="mb-6">
      <h1 class="text-h4 font-weight-bold mb-2">
        {{ t('roles.title') }}
      </h1>
      <p class="text-body-1 text-medium-emphasis">
        {{ t('roles.subtitle') }}
      </p>
    </div>

    <VRow>
      <!-- 👉 Roles Cards -->
      <VCol cols="12">
        <RoleCards @refresh-user-list="handleRefreshUserList" />
      </VCol>

      <VCol cols="12">
        <h4 class="text-h4 mb-1 mt-6">
          {{ t('roles.totalUsersWithRoles') }}
        </h4>
        <p class="text-body-1 mb-0">
          {{ t('roles.findUsersWithRoles') }}
        </p>
      </VCol>

      <VCol cols="12">
        <!-- 👉 User List  -->
        <UserList ref="userListRef" />
      </VCol>
    </VRow>
  </section>
</template>
